import { format } from '@bydesign-ui/utils';
import { TriggerTypeMap } from '../types';
export function wrapSyncFunc(fn) {
  return function (rule, value) {
    try {
      var errorTip = rule.errorTip;
      var result = fn(rule, value);

      if (result == null) {
        return Promise.resolve();
      }

      if (typeof result === 'string') {
        return Promise.reject(format(result, rule));
      }

      return result ? Promise.resolve() : Promise.reject(typeof errorTip === 'function' ? errorTip(rule) : typeof errorTip === 'string' ? format(errorTip, rule) : 'error');
    } catch (e) {
      return Promise.reject(e.message);
    }
  };
}
var REGISTERED_TYPE_MAP = {};
var REGISTERED_RULES = [];
export function registerTypeRule(type, func) {
  REGISTERED_TYPE_MAP[type] = func;
}
export function registerRule(func) {
  REGISTERED_RULES.push(func);
}
export function validateRule(context, rule, value) {
  var funcList = REGISTERED_RULES.slice();
  var type = rule.type;

  if (type != null) {
    var func = REGISTERED_TYPE_MAP[type];

    if (func == null) {
      return Promise.reject('invalid type `' + type + '`，call `registerTypeRule` first！');
    }

    funcList.unshift(func);
  }

  return new Promise(function (resolve, reject) {
    var count = funcList.length;
    var index = 0;

    var fn = function fn() {
      if (index === count) {
        resolve();
        return;
      }

      var func = funcList[index++];
      func.call(context, rule, value).then(fn).catch(reject);
    };

    fn();
  });
}
export function validate(context, rules, value) {
  var trigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'change';
  var triggerLevel = TriggerTypeMap[trigger];
  var matched = rules.filter(function (item) {
    return TriggerTypeMap[item.trigger || 'change'] <= triggerLevel;
  });
  var partial = matched.length < rules.length;
  return new Promise(function (resolve) {
    var count = matched.length;
    var index = 0;

    var fn = function fn() {
      if (index === count) {
        resolve({
          partial: partial,
          valid: true,
          msg: ''
        });
        return;
      }

      var ruleObj = matched[index++];
      validateRule(context, ruleObj, value).then(fn).catch(function (msg) {
        resolve({
          partial: partial,
          valid: false,
          msg: msg
        });
      });
    };

    fn();
  });
}